module.exports = __webpack_public_path__ + "files/1a1ba35d5999ce507bdcccf4ed7db0d2.png";